import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingUp } from "lucide-react";

const PHASES = ["Choosing", "Setting up", "Building", "Launched", "Promoting", "First sale", "Growing"];

export const ProgressBox = () => {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/coach/progress").then((r) => setP(r.data)).catch(() => {}); }, []);
  if (!p) return null;
  const idx = PHASES.indexOf(p.phase);
  return (
    <section className="mt-5 card-panel p-5" data-testid="account-your-progress">
      <div className="eyebrow text-[#FD0F10] flex items-center gap-2"><TrendingUp size={14} /> YOUR PROGRESS</div>
      {p.hustle && <div className="text-white font-bold mt-2" data-testid="progress-hustle">{p.hustle}</div>}
      <div className="mt-3 flex flex-wrap gap-1.5" data-testid="progress-phases">
        {PHASES.map((ph, i) => (
          <span key={ph} className={`text-[10px] font-mono-ui uppercase tracking-wider px-2 py-1 rounded border ${i === idx ? "bg-[#FD0F10] border-[#FD0F10] text-white" : i < idx ? "border-[#FD0F10]/50 text-gray-300" : "border-[#2A2E39] text-gray-500"}`} data-testid={`progress-phase-${i}`}>{ph}</span>
        ))}
      </div>
      <p className="text-sm text-gray-300 mt-3" data-testid="progress-phase-current">
        {p.phase ? `You're in: ${p.phase}${p.promo_step ? `. Working on: ${p.promo_step}` : ""}.` : "Tell your coach where you're at and it will track your progress here."}
      </p>
      <div className="mt-3 text-xs text-gray-400" data-testid="progress-accounts">
        Accounts set up: {p.accounts.length ? p.accounts.join(", ") : "none yet"}
      </div>
    </section>
  );
};
